<script>
    import LySection from '../components/LySection.svelte';
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     tag?: string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { tag = 'dl', mt = 0, mb = 0, children } = $props();

    const allowedTags = {
        dl: 'dl',
        div: 'div',
    };
    const thisTag = $derived(allowedTags[ValueService.toStringSingleLine(tag)] ?? 'dl');
</script>

<LySection tag={thisTag} {mt} {mb} addClass="lyListTwoCols">
    {@render children?.()}
    <div class="clear-both"></div>
</LySection>
